import { render } from "./RisetPage.vue?vue&type=template&id=9a5f1452&scoped=true"
import script from "./RisetPage.vue?vue&type=script&lang=js"
export * from "./RisetPage.vue?vue&type=script&lang=js"

import "./RisetPage.vue?vue&type=style&index=0&id=9a5f1452&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a5f1452"]])

export default __exports__